import React, { Component } from 'react';
import JobsAssignment from './Commons/JobsAssignment.js'

export default class PutawayJobs extends Component {
	render() {
		return (
			<div>
				<JobsAssignment operationName={'Putaway'} processType={'INWARDING'} userType={'INWARDING'} processPhase={'INWARDING_PICK'} allowMultipleUsers={true} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/PutawayJobs.js